const getBookingNumberOrLabelCancelled: (args: { bookingCode: string }) => string = ({ bookingCode }) => bookingCode

export default getBookingNumberOrLabelCancelled
